import React from 'react';
import Head from 'next/head';

import Layout from '../components/Layout';
import ContactUsComponent from '../components/ContactUs';

const ContactUs = () => (
  <Layout page="Contact Us">
    <Head>
      <title>Contact Us - Oneistox.com</title>
      <meta
        name="description"
        content="If you have any questions, just say hello through an email at support@oneistox.com. To get instant updates definitely follow us on on Instagram"
      />
      <meta
        data-hid="twitterDescription"
        name="twitter:description"
        content="If you have any questions, just say hello through an email at support@oneistox.com. To get instant updates definitely follow us on on Instagram"
      />

      <meta
        name="keywords"
        content="Architecture workshop, blogs, Design workshop in india"
      />
      <meta
        property="og:image"
        content={`${
          process.env.NEXT_PUBLIC_CDN
        }${'/images/metaImage/default.jpg'}`}
      ></meta>
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="oneistox.com" />
      <meta
        property="twitter:url"
        content="https://www.oneistox.com/contact-us"
      />
      <meta name="twitter:title" content="Contact Us - Oneistox.com" />
      <meta
        name="twitter:description"
        content="If you have any questions, just say hello through an email at support@oneistox.com. To get instant updates definitely follow us on on Instagram"
      ></meta>
      <meta
        name="twitter:image"
        content={`${
          process.env.NEXT_PUBLIC_CDN
        }${'/images/metaImage/default.jpg'}`}
      />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="627" />
    </Head>
    <ContactUsComponent />
  </Layout>
);

export default ContactUs;
